import User from "./User";
class TaskType {
  public id?: number;
  public tipotarea?: string;
  public color?: string;
  public activo?: boolean;
  public usuariosByTipoTarea?: Array<User>;
  constructor(id: number, tipotarea: string, color: string, activo: boolean, usuariosByTipoTarea?: Array<User>) {
    this.id = id;
    this.tipotarea = tipotarea;
    this.color = color;
    this.activo = activo;
    this.usuariosByTipoTarea = usuariosByTipoTarea;
  }
}

export default TaskType;
